
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Student } from '../interface/student';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class StudentsService {
  httpOptions: any;
  headers: any;
  user: any = 'shinto';
  isIEOrEdge: any = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent)

  private _refreshNeeded$ = new Subject<void>();
  private messageSource = new BehaviorSubject('messageData');
  currentMessage = this.messageSource.asObservable();

  get refreshNeeded$() {
    return this._refreshNeeded$;
  }

  constructor(private http: HttpClient) {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': this.user,
        'UserName': this.user,
        'Browser': this.isIEOrEdge
      })
    };
  }

  getAllStudents(url) {
    return this.http.get(url, this.httpOptions)
  }

  getStudentByID(url, param) {
    return this.http.post(url, param, this.httpOptions)
  }

  getStudentsByParam(url, param) {
    return this.http.post(url, param, this.httpOptions)
  }

  getStudentsByBatchID(url, param) {
    return this.http.post<Student>(url, param, this.httpOptions)
  }

  createStudent(url, param) {
    return this.http.post<Student>(url, param, this.httpOptions)
  }

  updateStudent(url, param) {
    return this.http.put<Student>(url, param, this.httpOptions)
  }

  getAllTempStudents(url) {
    return this.http.get(url, this.httpOptions)
  }

  changeMessage(message: any) {
    this.messageSource.next(message);

  }

  moveTempStudents(url) {
    return this.http.get(url, this.httpOptions)
      .pipe(
        tap(() => {
          this._refreshNeeded$.next();
        })
      );
  }
}

